import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystacabinpune() {



  const cardData = {




keyword: "Innova Crysta Cab in Pune",

headingDescription: "Garud Cab Service provides premium Innova Crysta Cab Service in Pune for airport transfers, corporate travel, family trips, outstation journeys, weddings, sightseeing, and long-distance transportation. The Innova Crysta offers spacious seating, comfortable interiors, generous luggage capacity, and a smooth ride, making it suitable for both short and extended journeys. Customers can book an Innova Crysta with a professional chauffeur for one-way trips, round trips, airport pickup and drop, and customized travel plans. With well-maintained vehicles, experienced drivers, transparent pricing, flexible pickup locations, and 24/7 customer assistance, Garud Cab Service delivers a convenient and comfortable travel experience across Pune and popular outstation destinations.",

topPlaces: [
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill station near Pune known for scenic valleys, waterfalls, forts, lakes, and beautiful monsoon landscapes. An Innova Crysta is an excellent choice for families and groups traveling from Pune because of its spacious cabin, comfortable seating, and generous luggage capacity. Customers can book a chauffeur-driven vehicle for one-way travel, round trips, or customized Lonavala sightseeing."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station known for viewpoints, strawberry farms, Venna Lake, waterfalls, and pleasant mountain weather. The comfortable Innova Crysta is suitable for families, couples, and groups planning a longer journey from Pune. Garud Cab Service provides flexible pickup options and chauffeur-driven vehicles for one-way trips, return journeys, and sightseeing tours."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance destination from Pune for beach holidays, family vacations, group tours, honeymoon trips, and weekend getaways. The Innova Crysta provides comfortable seating and sufficient luggage space for the extended road journey. Travelers can book a private chauffeur-driven cab from Pune to Goa with flexible travel schedules and one-way or round-trip options."
  },
  {
    title: "Nashik",
    description: "Nashik is a major Maharashtra destination known for Trimbakeshwar, Panchavati, temples, vineyards, and scenic surroundings. An Innova Crysta offers a comfortable travel option for families, devotees, and groups traveling from Pune. Garud Cab Service provides professional chauffeur-driven transportation for one-way journeys, return trips, and Nashik sightseeing."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is an important cultural and religious destination known for Mahalaxmi Temple, Panhala Fort, Rankala Lake, and its rich Maharashtrian heritage. Travelers from Pune can book an Innova Crysta for comfortable family or group travel. The spacious vehicle is suitable for both direct journeys and customized Kolhapur sightseeing."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of Maharashtra's most visited pilgrimage destinations and attracts devotees throughout the year for Sai Baba Darshan. An Innova Crysta is especially suitable for families, senior citizens, and groups traveling from Pune because of its comfortable seating and easy luggage accommodation. Garud Cab Service offers one-way and round-trip cab options for convenient pilgrimage travel."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad is a prominent heritage and pilgrimage destination known for Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga. The Innova Crysta provides a spacious and comfortable option for passengers planning this longer journey from Pune. Travelers can also customize their itinerary to include sightseeing and nearby historical attractions."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination from Pune known for beaches, sea forts, coastal scenery, and relaxing weekend experiences. An Innova Crysta is suitable for families and groups traveling together with luggage. Garud Cab Service provides convenient private cab bookings for Alibaug journeys, return travel, and customized sightseeing plans."
  },
  {
    title: "Satara",
    description: "Satara is a scenic Maharashtra destination offering access to Kaas Plateau, Thoseghar Waterfalls, Ajinkyatara Fort, and beautiful Sahyadri landscapes. It is suitable for family outings, nature trips, and weekend travel from Pune. Travelers can choose an Innova Crysta for comfortable seating, spacious luggage storage, and professional chauffeur-driven transportation."
  },
  {
    title: "Solapur",
    description: "Solapur is an important Maharashtra city visited for business travel, family functions, religious journeys, and personal work. The long-distance journey from Pune can be made more comfortable with an Innova Crysta, particularly for families and groups traveling together. Garud Cab Service offers flexible pickup arrangements and convenient one-way or round-trip bookings."
  }
],



"services": [
{
"name": "Innova on Rent in Pune",
"description": "Book Innova on Rent in Pune for comfortable and spacious travel with a professional chauffeur and well-maintained air-conditioned vehicle. Innova rental is suitable for family trips, local travel, airport transfers, corporate transportation, outstation journeys, sightseeing, and group travel with convenient pickup and drop arrangements."
},
{
"name": "Innova Crysta Rental Pune",
"description": "Choose Innova Crysta Rental Pune for premium chauffeur-driven transportation with spacious seating, comfortable interiors, powerful AC, and ample luggage capacity. The Innova Crysta is suitable for family travel, corporate journeys, airport transfers, sightseeing, outstation trips, business visits, and long-distance road travel."
},
{
"name": "Innova Car Rental Per Km in Pune",
"description": "Get Innova Car Rental Per Km in Pune with flexible travel options designed for local and outstation transportation. Choose a comfortable chauffeur-driven Innova for airport transfers, city travel, business trips, family journeys, sightseeing, and intercity routes according to your distance, passenger count, luggage, and travel requirements."
},
{
"name": "Innova Crysta on Rent Pune",
"description": "Hire Innova Crysta on Rent Pune for a premium and comfortable travel experience with professional chauffeurs, clean AC interiors, spacious seating, and generous luggage space. It is an excellent option for families, corporate travelers, tourists, airport transfers, outstation journeys, and customers requiring a reliable premium vehicle."
},
{
"name": "Pune Mumbai Innova Rental",
"description": "Book Pune Mumbai Innova Rental for convenient chauffeur-driven transportation between Pune and Mumbai. Travel comfortably in a spacious AC Innova with professional drivers and flexible one-way or round-trip options suitable for business travel, airport transfers, family journeys, corporate visits, and personal transportation."
},
{
"name": "Innova Crysta Cab in Pune",
"description": "Reserve an Innova Crysta Cab in Pune for premium private transportation with spacious seating, comfortable interiors, air conditioning, and professional chauffeur service. The vehicle is suitable for airport transfers, local travel, outstation trips, corporate transportation, family journeys, sightseeing, and long-distance travel."
},
{
"name": "Innova Crysta Taxi in Pune",
"description": "Choose Innova Crysta Taxi in Pune for comfortable and reliable chauffeur-driven transportation with a premium vehicle, spacious seating, clean interiors, and convenient pickup and drop facilities. The service is suitable for families, business travelers, tourists, airport passengers, and groups requiring comfortable private travel."
},
{
"name": "Innova Crysta on Rent in Pune",
"description": "Book Innova Crysta on Rent in Pune for flexible premium transportation with an experienced chauffeur and well-maintained AC vehicle. Enjoy spacious seating and luggage capacity for family trips, corporate travel, airport transfers, sightseeing, outstation journeys, business visits, and special travel requirements."
},
{
"name": "Innova Crysta Car Rental Pune",
"description": "Hire Innova Crysta Car Rental Pune for comfortable chauffeur-driven travel across Pune and nearby destinations. The premium MUV provides spacious seating, powerful AC, clean interiors, and luggage space, making it suitable for families, corporate groups, tourists, airport transfers, and long-distance outstation journeys."
},
{
"name": "Innova Crysta Cab Service Pune",
"description": "Choose Innova Crysta Cab Service Pune for dependable premium transportation with professional chauffeurs and comfortable AC vehicles. The service can be arranged for local travel, airport transfers, corporate transportation, family trips, sightseeing, outstation journeys, business visits, and scheduled one-way or round-trip travel."
},
{
"name": "Innova Crysta Hire in Pune",
"description": "Hire an Innova Crysta in Pune for premium and spacious chauffeur-driven transportation with flexible pickup and drop arrangements. The vehicle is suitable for families, corporate travelers, tourists, airport passengers, groups, business meetings, sightseeing trips, and comfortable long-distance journeys."
},
{
"name": "Innova Crysta Taxi Service Pune",
"description": "Book Innova Crysta Taxi Service Pune for reliable private transportation with experienced chauffeurs, spacious seating, air conditioning, and comfortable interiors. Choose the service for airport transfers, corporate travel, family journeys, sightseeing, local transportation, outstation trips, and intercity travel."
},
{
"name": "Innova Crysta Airport Cab Pune",
"description": "Reserve an Innova Crysta Airport Cab Pune for convenient airport pickup and drop with spacious luggage capacity and comfortable AC travel. Professional chauffeurs provide private transportation to and from Pune Airport, making the service suitable for families, corporate passengers, tourists, and groups carrying multiple bags."
},
{
"name": "Innova Crysta Outstation Cab Pune",
"description": "Book Innova Crysta Outstation Cab Pune for comfortable long-distance travel with a professional chauffeur and premium AC vehicle. Spacious seating and luggage capacity make it suitable for family vacations, corporate journeys, weekend trips, sightseeing, religious travel, business visits, and one-way or round-trip outstation transportation."
},
{
"name": "Innova Crysta Local Cab Pune",
"description": "Choose Innova Crysta Local Cab Pune for comfortable city transportation with flexible hourly or scheduled travel arrangements. The premium vehicle is suitable for family outings, corporate meetings, shopping, sightseeing, events, hotel transfers, local appointments, and customers requiring a spacious chauffeur-driven cab within Pune."
},
{
"name": "Innova Crysta Corporate Cab Pune",
"description": "Arrange Innova Crysta Corporate Cab Pune for premium employee and executive transportation with professional chauffeurs, comfortable seating, clean AC interiors, and reliable scheduling. The service is suitable for business meetings, corporate events, client visits, airport transfers, office travel, and executive transportation requirements."
},
{
"name": "Innova Crysta Wedding Cab Pune",
"description": "Book Innova Crysta Wedding Cab Pune for comfortable guest and family transportation during wedding functions and special events. Spacious seating, premium interiors, air conditioning, professional chauffeur service, and flexible pickup arrangements make the vehicle suitable for venue transfers, guest movement, family travel, and wedding-related transportation."
},
{
"name": "Innova Crysta Family Cab Pune",
"description": "Reserve Innova Crysta Family Cab Pune for spacious and comfortable family transportation with ample luggage capacity and professional chauffeur service. The vehicle is suitable for vacations, airport transfers, sightseeing, family functions, weekend trips, religious journeys, and long-distance travel with comfortable AC interiors."
},
{
"name": "Innova Crysta Cab in Hinjewadi",
"description": "Book Innova Crysta Cab in Hinjewadi for comfortable chauffeur-driven transportation for corporate travel, airport transfers, family journeys, local travel, and outstation trips. Enjoy convenient pickup, spacious seating, air conditioning, professional drivers, and flexible travel arrangements from Hinjewadi to Pune and other destinations."
},
{
"name": "Innova Crysta Cab in Wakad",
"description": "Choose Innova Crysta Cab in Wakad for premium and convenient transportation with spacious seating, clean AC interiors, and experienced chauffeurs. The service is suitable for airport transfers, corporate travel, family trips, local journeys, sightseeing, and outstation transportation from Wakad to various destinations."
},
{
"name": "Innova Crysta Cab in Baner",
"description": "Reserve Innova Crysta Cab in Baner for comfortable private transportation with professional chauffeurs and a spacious premium vehicle. It is suitable for business meetings, airport transfers, family travel, hotel transfers, local sightseeing, outstation trips, and corporate transportation requirements from Baner."
},
{
"name": "Innova Crysta Cab in Hadapsar",
"description": "Book Innova Crysta Cab in Hadapsar for dependable premium transportation with comfortable AC interiors, spacious seating, and professional chauffeur service. The vehicle is suitable for corporate travel, airport transfers, family journeys, local transportation, sightseeing, and outstation trips from Hadapsar."
},
{
"name": "Innova Crysta Cab in Kharadi",
"description": "Hire Innova Crysta Cab in Kharadi for comfortable and reliable transportation with convenient pickup and drop facilities. Spacious seating, luggage capacity, air conditioning, and professional chauffeurs make the service suitable for corporate travelers, airport passengers, families, tourists, and outstation journeys."
},
{
"name": "Innova Crysta Cab in Pimpri Chinchwad",
"description": "Choose Innova Crysta Cab in Pimpri Chinchwad for premium chauffeur-driven transportation suitable for families, corporate travelers, airport transfers, sightseeing, local travel, and outstation journeys. Enjoy a spacious AC vehicle with comfortable interiors, professional service, and flexible pickup arrangements."
},
{
"name": "Innova Crysta Cab Near Me Pune",
"description": "Find an Innova Crysta Cab Near Me Pune for convenient premium transportation from your preferred location. Enjoy quick pickup arrangements, spacious seating, air-conditioned interiors, professional chauffeur service, and flexible travel options for airport transfers, local trips, family journeys, corporate travel, and outstation destinations."
},
{
"name": "Pune to Mumbai Innova Crysta Cab",
"description": "Book Pune to Mumbai Innova Crysta Cab for a comfortable premium journey between Pune and Mumbai with professional chauffeur service and spacious AC interiors. The vehicle is suitable for families, corporate travelers, airport transfers, business visits, personal travel, one-way drops, and round-trip journeys."
},
{
"name": "Pune Airport Innova Crysta Taxi",
"description": "Reserve Pune Airport Innova Crysta Taxi for premium airport pickup and drop with spacious luggage capacity, comfortable seating, and professional chauffeur service. The service is suitable for families, business travelers, tourists, executives, and groups seeking a reliable and comfortable transfer to or from Pune Airport."
},
{
"name": "Pune to Nashik Innova Crysta Cab",
"description": "Hire Pune to Nashik Innova Crysta Cab for a spacious and comfortable intercity journey with a professional chauffeur and premium AC vehicle. It is suitable for family travel, corporate visits, sightseeing, religious trips, personal journeys, one-way drops, and round-trip travel between Pune and Nashik."
},
{
"name": "Pune to Goa Innova Crysta Cab",
"description": "Book Pune to Goa Innova Crysta Cab for premium long-distance transportation with comfortable AC interiors, spacious seating, ample luggage capacity, and professional chauffeur service. The vehicle is suitable for family vacations, group travel, corporate journeys, weekend trips, sightseeing, and one-way or round-trip Goa travel."
},
{
"name": "Pune to Shirdi Innova Crysta Cab",
"description": "Reserve Pune to Shirdi Innova Crysta Cab for a comfortable and spacious religious journey with professional chauffeur service and convenient pickup arrangements. The premium AC vehicle is suitable for families, senior passengers, groups, and travelers planning one-way, round-trip, or sightseeing travel to Shirdi."
},
{
"name": "Pune to Kolhapur Innova Crysta Cab",
"description": "Choose Pune to Kolhapur Innova Crysta Cab for comfortable and reliable intercity transportation with premium interiors, spacious seating, ample luggage space, and an experienced chauffeur. The service is suitable for family trips, corporate travel, personal visits, sightseeing, one-way drops, and round-trip journeys."
}
],
"tableData": [
["Innova on Rent in Pune", "Innova Crysta Rental Pune"],
["Innova Car Rental Per Km in Pune", "Innova Crysta on Rent Pune"],
["Pune Mumbai Innova Rental", "Innova Crysta Cab in Pune"],
["Innova Crysta Taxi in Pune", "Innova Crysta on Rent in Pune"],
["Innova Crysta Car Rental Pune", "Innova Crysta Cab Service Pune"],
["Innova Crysta Hire in Pune", "Innova Crysta Taxi Service Pune"],
["Innova Crysta Airport Cab Pune", "Innova Crysta Outstation Cab Pune"],
["Innova Crysta Local Cab Pune", "Innova Crysta Corporate Cab Pune"],
["Innova Crysta Wedding Cab Pune", "Innova Crysta Family Cab Pune"],
["Innova Crysta Cab in Hinjewadi", "Innova Crysta Cab in Wakad"],
["Innova Crysta Cab in Baner", "Innova Crysta Cab in Hadapsar"],
["Innova Crysta Cab in Kharadi", "Innova Crysta Cab in Pimpri Chinchwad"],
["Innova Crysta Cab Near Me Pune", "Pune to Mumbai Innova Crysta Cab"],
["Pune Airport Innova Crysta Taxi", "Pune to Nashik Innova Crysta Cab"],
["Pune to Goa Innova Crysta Cab", "Pune to Shirdi Innova Crysta Cab"],
["Pune to Kolhapur Innova Crysta Cab", ""]
],



whychoose: [
  {
    WhyChooseheading: "Premium Innova Crysta Cab in Pune",
    WhyChoosedescription: "Garud Cab Service provides Innova Crysta cabs in Pune for customers seeking a spacious and refined travel experience for airport transfers, outstation journeys, corporate transportation, family trips, and special occasions."
  },
  {
    WhyChooseheading: "Spacious Seating for Comfortable Travel",
    WhyChoosedescription: "The Innova Crysta offers generous cabin space and comfortable seating, making it a practical choice for passengers who want extra room during city travel as well as longer highway journeys."
  },
  {
    WhyChooseheading: "Ideal for Airport & Corporate Transfers",
    WhyChoosedescription: "Businesses and frequent travellers can use Innova Crysta cabs for Pune airport transfers, client meetings, executive travel, employee transportation, conferences, and other professional requirements."
  },
  {
    WhyChooseheading: "Reliable Choice for Outstation Trips",
    WhyChoosedescription: "Plan long-distance journeys from Pune to Mumbai, Goa, Nashik, Mahabaleshwar, Kolhapur, Aurangabad, Shirdi, and other destinations with a vehicle designed for comfortable intercity travel."
  },
  {
    WhyChooseheading: "Suitable for Families & Small Groups",
    WhyChoosedescription: "Families and groups can benefit from the spacious interior and luggage capacity of the Innova Crysta, making it suitable for vacations, weddings, religious trips, and weekend getaways."
  },
  {
    WhyChooseheading: "Clean Vehicle & Professional Chauffeur",
    WhyChoosedescription: "Garud Cab Service focuses on providing well-maintained vehicles and professional drivers to create a comfortable travel environment for customers booking Innova Crysta transportation in Pune."
  },
  {
    WhyChooseheading: "Available for One-Way & Round Trips",
    WhyChoosedescription: "Book the Innova Crysta for a one-way destination transfer, round-trip travel, local usage, airport pickup, or an extended outstation journey according to your transportation needs."
  },
  {
    WhyChooseheading: "Book Innova Crysta with Garud Cab Service",
    WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, and trip requirement to check suitable Innova Crysta cab arrangements with Garud Cab Service in Pune."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Innova Crysta Cab in Pune?",
    answer: "Yes, Garud Cab Service provides Innova Crysta cab services in Pune for local travel, airport transfers, corporate transportation, family trips, and outstation journeys."
  },
  {
    question: "Can I book an Innova Crysta for outstation travel?",
    answer: "Yes, Innova Crysta cabs can be booked for outstation journeys from Pune, including one-way and round-trip travel."
  },
  {
    question: "Is Innova Crysta suitable for family trips?",
    answer: "Yes, its spacious seating and luggage capacity make the Innova Crysta a suitable option for families and small groups travelling together."
  },
  {
    question: "Can I book an Innova Crysta for Pune Airport?",
    answer: "Yes, Innova Crysta airport pickup and drop services can be arranged for passengers travelling to or from Pune Airport."
  },
  {
    question: "Is Innova Crysta available for corporate travel?",
    answer: "Yes, corporate customers can use Innova Crysta cabs for executive travel, meetings, client visits, conferences, employee transportation, and business trips."
  },
  {
    question: "Can I book an Innova Crysta for a one-way trip?",
    answer: "Yes, one-way Innova Crysta cab bookings are available for suitable routes and destinations based on vehicle availability."
  },
  {
    question: "Can I hire an Innova Crysta for a wedding?",
    answer: "Yes, Innova Crysta cabs can be arranged for wedding transportation, guest transfers, family functions, events, and related travel requirements."
  },
  {
    question: "Which destinations can I travel to from Pune?",
    answer: "Innova Crysta cabs can be arranged for destinations such as Mumbai, Goa, Nashik, Mahabaleshwar, Kolhapur, Shirdi, Aurangabad, and other suitable outstation locations."
  },
  {
    question: "Can I book an Innova Crysta with a driver?",
    answer: "Yes, Garud Cab Service provides chauffeur-driven Innova Crysta cab arrangements for customers who prefer a convenient and professionally managed journey."
  },
  {
    question: "How can I book an Innova Crysta Cab in Pune?",
    answer: "Share your pickup location, destination, travel date, passenger details, and trip type with Garud Cab Service to arrange a suitable Innova Crysta cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Jadhav",
    feedback: "We selected an Innova Crysta for our family outstation trip from Pune. The spacious cabin was comfortable for everyone and there was enough room for our luggage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mr. Arjun Mehta",
    feedback: "I needed a premium vehicle for corporate travel in Pune and chose the Innova Crysta. The vehicle was comfortable and well suited for meetings and client transportation.",
    rating: 5
  }
];










  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta Cab in Pune",
  "image": "https://garudcabs.com/assets/images/innova-crysta-cab-in-pune.webp",
  "description": "Book an Innova Crysta Cab in Pune with Garud Cab for comfortable, spacious, and reliable local and outstation travel. Get Innova Crysta rental services in Pune for airport transfers, Pune to Mumbai trips, family journeys, corporate travel, sightseeing, and long-distance routes with flexible rental and per-kilometer options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/innova-crysta-cab-in-pune"
  }
};

  return (
    <div>



<Helmet>
  <title>Innova Crysta Cab in Pune | Rental & Taxi Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book an Innova Crysta Cab in Pune with Garud Cab for spacious and comfortable local, airport, and outstation travel. Get Innova Crysta rental and taxi services in Pune for Pune to Mumbai trips, family travel, corporate journeys, and sightseeing."
  />

  <meta
    name="keywords"
    content="Innova on rent in Pune, Innova Crysta rental Pune, Innova car rental per km in Pune, Innova Crysta on rent Pune, Pune Mumbai Innova rental, Innova Crysta cab in Pune, Innova Crysta on rent in Pune, Innova Crysta taxi in Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystacabinpune;